

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { AddressViewObject, DeliveryAddressViewObject } from '@/types/apiServerContract';
import { Prop } from 'vue-property-decorator';
import siteService from '@/project/site/site.service';
import dictionaryService from '@/core/translation/dictionary.service';

@Component
export default class AddressCard extends Vue {
    @Prop(String)
    private headingLabel!: string;

    @Prop(Object)
    private address!: AddressViewObject | DeliveryAddressViewObject | null;

    @Prop(String)
    private headerClass!: string;

    @Prop(String)
    private bodyClass!: string;

    @Prop(Boolean)
    private validate!: boolean;

    private countryLabel(countryCode: string): string {
        return siteService.countryLabel(countryCode);
    }

    private get validationErrors() {
        if (!this.validate || !this.address) return [];

        const fieldsToValidate: Array<(keyof DeliveryAddressViewObject)> =
        ['companyName', 'street', 'postalCode', 'city'];

        const fieldLabelErrors = {
            companyName: 'Checkout.Address.CompanyNameField',
            street: 'Checkout.Address.StreetAndNoField',
            postalCode: 'Checkout.Address.PostalCodeField',
            city: 'Checkout.Address.CityField'
        };

        const requiredLabel = dictionaryService.get('Validation.Required');

        return fieldsToValidate
            .filter(x => !this.address![x])
            .map(x => ({
                field: x,
                msg: dictionaryService.get(fieldLabelErrors[x]),
                errorLabel: requiredLabel
            }));
    }

    public isValid() {
        return this.validationErrors.length === 0;
    }
}
